module.exports = __webpack_public_path__ + "img/about.883a6dd7.webp";